const env = location.host.split('.')[0].match(/(qc|box)\d?/g)
const spell = !!env ? (env.length > 0 ? `-${env[0]}` : '') : ''
const WXDOMAIN = `//wx${spell}.xinli001.com/`,
  LXDOMAIN = spell?`//lingxi${spell}.xinli001.com/lingxi/service/`:`//m-lingxi${spell}.xinli001.com/lingxi/service/`,
  YIAPI = `//yiapi${spell}.xinli001.com/v5/yi/`,
  APIS = {
    // 免登+先测试后付费（for微博） 
    doFirstAfterBuyCreateOrder: `${LXDOMAIN}notLogin/doFirstAfterBuy/createOrder`, // 免登+先测试后付费（for微博） 创建订单
    weiboAuth: `${LXDOMAIN}notLogin/weiboAuth?from=wb`, // 微博授权接口
  }

export default APIS



// WEBPACK FOOTER //
// ./src/apis/weibo.js